__turbopack_context__.v({
  "chips": "readouts-page-module__sF4_ka__chips",
  "content": "readouts-page-module__sF4_ka__content",
  "datePill": "readouts-page-module__sF4_ka__datePill",
  "dayModalAvatar": "readouts-page-module__sF4_ka__dayModalAvatar",
  "dayModalBackdrop": "readouts-page-module__sF4_ka__dayModalBackdrop",
  "dayModalClose": "readouts-page-module__sF4_ka__dayModalClose",
  "dayModalDialog": "readouts-page-module__sF4_ka__dayModalDialog",
  "dayModalHeader": "readouts-page-module__sF4_ka__dayModalHeader",
  "dayModalIdentity": "readouts-page-module__sF4_ka__dayModalIdentity",
  "dayModalList": "readouts-page-module__sF4_ka__dayModalList",
  "dayModalRow": "readouts-page-module__sF4_ka__dayModalRow",
  "dayModalRowBody": "readouts-page-module__sF4_ka__dayModalRowBody",
  "dayModalRowCta": "readouts-page-module__sF4_ka__dayModalRowCta",
  "dayModalRowMeta": "readouts-page-module__sF4_ka__dayModalRowMeta",
  "dayModalRowTitle": "readouts-page-module__sF4_ka__dayModalRowTitle",
  "dayModalSub": "readouts-page-module__sF4_ka__dayModalSub",
  "dayModalTitle": "readouts-page-module__sF4_ka__dayModalTitle",
  "dot": "readouts-page-module__sF4_ka__dot",
  "empty": "readouts-page-module__sF4_ka__empty",
  "footerBar": "readouts-page-module__sF4_ka__footerBar",
  "headline": "readouts-page-module__sF4_ka__headline",
  "heroCarve": "readouts-page-module__sF4_ka__heroCarve",
  "heroMesh": "readouts-page-module__sF4_ka__heroMesh",
  "heroMock": "readouts-page-module__sF4_ka__heroMock",
  "heroMockCard": "readouts-page-module__sF4_ka__heroMockCard",
  "heroMockChipBright": "readouts-page-module__sF4_ka__heroMockChipBright",
  "heroMockChipDim": "readouts-page-module__sF4_ka__heroMockChipDim",
  "heroMockChipDotRing": "readouts-page-module__sF4_ka__heroMockChipDotRing",
  "heroMockChipDotSolid": "readouts-page-module__sF4_ka__heroMockChipDotSolid",
  "heroMockChipLines": "readouts-page-module__sF4_ka__heroMockChipLines",
  "heroMockChips": "readouts-page-module__sF4_ka__heroMockChips",
  "heroMockDotA": "readouts-page-module__sF4_ka__heroMockDotA",
  "heroMockDotB": "readouts-page-module__sF4_ka__heroMockDotB",
  "heroMockDots": "readouts-page-module__sF4_ka__heroMockDots",
  "heroMockFloatChip": "readouts-page-module__sF4_ka__heroMockFloatChip",
  "heroMockFloatDot": "readouts-page-module__sF4_ka__heroMockFloatDot",
  "heroMockGrid": "readouts-page-module__sF4_ka__heroMockGrid",
  "heroMockHead": "readouts-page-module__sF4_ka__heroMockHead",
  "heroMockMonth": "readouts-page-module__sF4_ka__heroMockMonth",
  "heroMockOrb": "readouts-page-module__sF4_ka__heroMockOrb",
  "heroMockOrbDot": "readouts-page-module__sF4_ka__heroMockOrbDot",
  "heroPill": "readouts-page-module__sF4_ka__heroPill",
  "heroPillText": "readouts-page-module__sF4_ka__heroPillText",
  "heroPlate": "readouts-page-module__sF4_ka__heroPlate",
  "heroShader": "readouts-page-module__sF4_ka__heroShader",
  "heroStandfirst": "readouts-page-module__sF4_ka__heroStandfirst",
  "heroStat": "readouts-page-module__sF4_ka__heroStat",
  "heroStatAvatar": "readouts-page-module__sF4_ka__heroStatAvatar",
  "heroStatDrugRow": "readouts-page-module__sF4_ka__heroStatDrugRow",
  "heroStatDrugText": "readouts-page-module__sF4_ka__heroStatDrugText",
  "heroStatKey": "readouts-page-module__sF4_ka__heroStatKey",
  "heroStatSub": "readouts-page-module__sF4_ka__heroStatSub",
  "heroStatVal": "readouts-page-module__sF4_ka__heroStatVal",
  "heroStatValQuiet": "readouts-page-module__sF4_ka__heroStatValQuiet",
  "heroStatWide": "readouts-page-module__sF4_ka__heroStatWide",
  "heroStats": "readouts-page-module__sF4_ka__heroStats",
  "heroTitle": "readouts-page-module__sF4_ka__heroTitle",
  "heroTitleBlock": "readouts-page-module__sF4_ka__heroTitleBlock",
  "item": "readouts-page-module__sF4_ka__item",
  "meta": "readouts-page-module__sF4_ka__meta",
  "miniCard": "readouts-page-module__sF4_ka__miniCard",
  "miniId": "readouts-page-module__sF4_ka__miniId",
  "miniMonogram": "readouts-page-module__sF4_ka__miniMonogram",
  "miniName": "readouts-page-module__sF4_ka__miniName",
  "miniSub": "readouts-page-module__sF4_ka__miniSub",
  "miniTrial": "readouts-page-module__sF4_ka__miniTrial",
  "mobileAgenda": "readouts-page-module__sF4_ka__mobileAgenda",
  "mobileAgendaEmpty": "readouts-page-module__sF4_ka__mobileAgendaEmpty",
  "mobileAgendaHead": "readouts-page-module__sF4_ka__mobileAgendaHead",
  "monthLabel": "readouts-page-module__sF4_ka__monthLabel",
  "monthMarker": "readouts-page-module__sF4_ka__monthMarker",
  "monthMeta": "readouts-page-module__sF4_ka__monthMeta",
  "nctId": "readouts-page-module__sF4_ka__nctId",
  "page": "readouts-page-module__sF4_ka__page",
  "phaseChip": "readouts-page-module__sF4_ka__phaseChip",
  "rail": "readouts-page-module__sF4_ka__rail",
  "readoutDayFade": "readouts-page-module__sF4_ka__readoutDayFade",
  "readoutDayRise": "readouts-page-module__sF4_ka__readoutDayRise",
  "review": "readouts-page-module__sF4_ka__review",
  "source": "readouts-page-module__sF4_ka__source",
  "span": "readouts-page-module__sF4_ka__span",
  "spanEndpoint": "readouts-page-module__sF4_ka__spanEndpoint",
  "spanEndpointEnd": "readouts-page-module__sF4_ka__spanEndpointEnd",
  "spanEndpointLabel": "readouts-page-module__sF4_ka__spanEndpointLabel",
  "spanEndpointWrap": "readouts-page-module__sF4_ka__spanEndpointWrap",
  "spanLine": "readouts-page-module__sF4_ka__spanLine",
  "spanMark": "readouts-page-module__sF4_ka__spanMark",
  "spanMarkDate": "readouts-page-module__sF4_ka__spanMarkDate",
  "spanMarkDateAbove": "readouts-page-module__sF4_ka__spanMarkDateAbove",
  "spanMarkWrap": "readouts-page-module__sF4_ka__spanMarkWrap",
  "spanTipMeta": "readouts-page-module__sF4_ka__spanTipMeta",
  "spanTipTitle": "readouts-page-module__sF4_ka__spanTipTitle",
  "spanTitle": "readouts-page-module__sF4_ka__spanTitle",
  "spanTrack": "readouts-page-module__sF4_ka__spanTrack",
  "strip": "readouts-page-module__sF4_ka__strip",
  "stripAvatar": "readouts-page-module__sF4_ka__stripAvatar",
  "stripCell": "readouts-page-module__sF4_ka__stripCell",
  "stripCount": "readouts-page-module__sF4_ka__stripCount",
  "stripHead": "readouts-page-module__sF4_ka__stripHead",
  "stripIdentity": "readouts-page-module__sF4_ka__stripIdentity",
  "stripLabel": "readouts-page-module__sF4_ka__stripLabel",
  "stripManage": "readouts-page-module__sF4_ka__stripManage",
  "stripName": "readouts-page-module__sF4_ka__stripName",
  "stripRow": "readouts-page-module__sF4_ka__stripRow",
  "summary": "readouts-page-module__sF4_ka__summary",
  "timeline": "readouts-page-module__sF4_ka__timeline",
  "typeChip": "readouts-page-module__sF4_ka__typeChip",
  "viewPanel": "readouts-page-module__sF4_ka__viewPanel",
  "viewTab": "readouts-page-module__sF4_ka__viewTab",
  "viewTabIndicator": "readouts-page-module__sF4_ka__viewTabIndicator",
  "viewTabs": "readouts-page-module__sF4_ka__viewTabs",
  "when": "readouts-page-module__sF4_ka__when",
});
